import { render, staticRenderFns } from "./file-manager-progress-widget.vue?vue&type=template&id=4c08a714&scoped=true"
import script from "./file-manager-progress-widget.vue?vue&type=script&lang=js"
export * from "./file-manager-progress-widget.vue?vue&type=script&lang=js"
import style0 from "./file-manager-progress-widget.vue?vue&type=style&index=0&id=4c08a714&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c08a714",
  null
  
)

export default component.exports